import React from 'react';
import { App, Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
import styles from './YourTownloopOrdersList.module.scss';
import { saveToCart } from '@/api/cart';
import { saveOrderDelete, saveOrderCancel,saveOrderRefund } from '@/api/order';

import { orderRefundStatusOptionsMapper } from '@/utils/constants';
import { useTranslation } from 'react-i18next';
// 规格类型
interface Spec {
  lable: string;
  value: string;
  product_base_attribute_id: number;
  is_custom_attribute?: boolean;
}

// 订单商品类型
interface OrderProduct {
  id: string;
  product_id: string;
  product_sku_id: string;
  img: string;
  title: string;
  specs: Spec[];
  price: string;
  quantity: number;
  product_order_id?: string;
  subtotalPrice?: string;
}

// 订单类型
interface Order {
  odId: string;
  id: string;
  date: string;
  orderNumber: string;
  store: string;
  status: string;
  order_status: number;
  product_order_refund: {product_order_refund_status:number} | null;
  products: Array<{
    id: string;
    product_id: string;
    product_sku_id: string;
    img: string;
    title: string;
    specs: Spec[];
    price: string;
    quantity: number;
    product_order_id: string;
    subtotalPrice: string;
  }>;
  paidAmount: string;
  shippingFee: string;
  is_delete?: boolean;
}

interface YourTownloopOrdersListProps {
  orders: Order[];
  getId?: (id: string, action: string) => void;
  
}



// 订单状态映射 - 使用枚举
const getOrderStatusText = (status: number): string => {
  
  const orderStatusOptions = orderRefundStatusOptionsMapper();
  const statusOption = orderStatusOptions.find(option => option.value === status);
  return statusOption?.label || 'Unknown Status';
};


const YourTownloopOrdersList: React.FC<YourTownloopOrdersListProps> = ({ orders, getId }) => {
  const { t, i18n } = useTranslation();
  const { message } = App.useApp();
  const navigate = useNavigate();

  // 加入购物车 - 暂时注释掉
  // const handleAddToCart = (order: Order) => {
  //   const product = product; // 获取第一个商品
  //   const params = {
  //     product_id: product.product_id,
  //     product_sku_id: product.product_sku_id,
  //     quantity: product.quantity
  //   };

  //   saveToCart(params).then((res) => {
  //     if (res.code === 200) {
  //       message.success('成功加入购物车');
  //     } else {
  //       message.error(res.message || '加入购物车失败');
  //     }
  //   }).catch((error) => {
  //     console.error('加入购物车失败:', error);
  //     message.error('加入购物车失败，请重试');
  //   });
  // };

  // Buy Now 方法 - 类似ProductDetail中的OrderDetails
  const OrderDetails = (order: any) => {
    console.log(order, 'orderorderorderorder');

    // 传递订单ID用于获取订单详情 - 使用btoa编码
    const encodedOrderId = btoa(order.id);
    navigate(`/PlaceOrder?orderId=${encodedOrderId}`);
  };

  // 删除订单确认
  const handleDeleteOrder = (order: Order) => {
    Modal.confirm({
      title: `${t("YourTownloopOrdersList.ConfirmDeleteOrder")}`,
      content: `${t("YourTownloopOrdersList.WantDeleteOrder")} ${t("YourTownloopOrdersList.Thisactioncannotbeundone")}`,
      okText: `${t("YourTownloopOrdersList.Delete")}`,
      okType: 'danger',
      cancelText: `${t("YourTownloopOrdersList.Cancel")}`,
      onOk: async () => {
        try {
          const params = {
            product_order_id: order.id
          };

          const res = await saveOrderDelete(params);
          if (res.code === 200) {
            message.success('Order  deleted successfully');
            // 调用父组件的删除方法，用于刷新列表
            getId && getId(order.id, 'delete');
          } else {
            message.error(res.message || 'Delete failed');
          }
        } catch (error) {
          console.error('Delete order failed:', error);
          message.error('Delete failed, please try again');
        }
      },
    });
  };

  // 取消订单确认
  const handleOrderCancelled = (order: Order) => {
    Modal.confirm({
      title: '{t("YourTownloopOrdersList.ConfirmCancelOrder")}',
      content: `{t("YourTownloopOrdersList.WantCancelOrder")} ${order.orderNumber}? {t("YourTownloopOrdersList.Thisactioncannotbeundone")}`,
       okText: '{t("YourTownloopOrdersList.CancelOrder")}',
      okType: 'danger',
      cancelText: '{t("YourTownloopOrdersList.ON")}',

      onOk: async () => {
        try {
          const params = {
            product_order_id: order.id
          };

          const res = await saveOrderCancel(params);
          if (res.code === 200) {
            message.success('Order cancelled successfully');
            // 用于刷新列表
            getId && getId(order.id, 'cancel');
          } else {
            message.error(res.message || 'Cancel order failed');
          }
        } catch (error) {
          console.error('Cancel order failed:', error);
          message.error('Cancel order failed, please try again');
        }
      }
    });
  };


  // 已付款退款操作
  const handleOrderRefund = (order: Order) => {
    Modal.confirm({
      title: 'Confirm Refund Order',
      content: `Are you sure you want to refund order ${order.orderNumber}? This action cannot be undone.`,
      okText: 'Refund Order',
      okType: 'danger',
      cancelText: 'No',
      onOk: async () => {
        try {
          const params = {
            product_order_id: order.id
          };

          const res = await saveOrderRefund(params);
          if (res.code === 200) {
            message.success('Order refunded successfully');
            // 用于刷新列表
            getId && getId(order.id, 'refund');
          } else {
            message.error(res.message || 'Refund order failed');
          }
        } catch (error) {
          console.error('Refund order failed:', error);
          message.error('Refund order failed, please try again');
        }
      }
    });
  };

  return (
    <div className={styles['orders-list-wrapper']}>
      {/* 表头 */}
      <div className={styles['orders-list-header']}>
        <div className={styles['header-info']}>{t('YourTownloopOrdersList.OrderInformation')}</div>
        <div className={styles['header-amount']}>{t('YourTownloopOrdersList.GoodsAmount')}</div>
        <div className={styles['header-paid']}>{t('YourTownloopOrdersList.PaidAmount')}</div>
        <div className={styles['header-handle']}>{t('YourTownloopOrdersList.OrderHandling')}</div>
      </div>
      {orders.map(order => (
        <div className={styles['order-block']} key={order.id}>
          {/* 订单头部 */}
          <div className={styles['order-header']}>
            <div className={styles['order-header-left']}>
              <span className={styles['order-date']}>{order.date}</span>
              <span className={styles['order-number']}>{t('YourTownloopOrdersList.OrderNumber')}:{order.orderNumber}</span>

              {(order.order_status === 2 || order.order_status === 5) && (
                <span 
                  className={styles['order-details']}
                  onClick={() => handleDeleteOrder(order)}
                >{t('YourTownloopOrdersList.Delete')} &gt;</span>
              )}
              




              {/* 用户付款后未退款 */}
              {(!order.product_order_refund && order.order_status === 3) && (
                // 已付款退款操作
                <span 
                className={styles['order-details']}
                onClick={() => handleOrderRefund(order)}
              >Refund &gt;</span>
              )}

             

              {/* <span className={styles['order-store']}>{order.store}</span> */}

              {/* 确认收货 */}
              {(!order.product_order_refund && order.order_status === 3) && (
                // 已付款退款操作
                <span 
                className={styles['order-details']}
                onClick={() => OrderDetails(order)}
                // 未付款状态下可以去订单详情页付款
              >Confirm Receipt &gt;</span>
              )}

            
              <span 
                className={styles['order-details']}
                onClick={() => OrderDetails(order)}
                // 未付款状态下可以去订单详情页付款
              >{order.order_status === 1 ? t('YourTownloopOrdersList.Checkout')  : t('YourTownloopOrdersList.OrderDetails')} &gt;</span>
              {(order.order_status === 1) && (
                // 未付款取消
                <span 
                className={styles['order-cancel']}
                onClick={() => handleOrderCancelled(order)}
              >{t('YourTownloopOrdersList.CancelOrder')}</span>
              )}

            </div>
            <div className={styles['order-header-right']}>
              <span className={styles['order-status']}>{t('YourTownloopOrdersList.'+order.status)}</span>
            </div>
          </div>




          {/* 商品信息区块 */}
          {order.products.map((product, index) => (
            <div className={styles['order-body']} key={index}>
              <div className={styles['order-product-info']}>
                <img className={styles['product-img']} onClick={() => navigate(`/ProductDetail/${product?.product_id}`)} src={product?.img} alt={product?.title} />
                <div className={styles['product-detail']}>
                  <div className={styles['product-title']} title={product?.title}>
                    {product?.title}
                    {/* {order.products.length > 1 && (
                    <span className={styles['product-count']}> +{order.products.length - 1} more</span>
                  )} */}
                  </div>
                  <div className={styles['product-specs']}>
                    {product?.specs && product?.specs.length > 0 ? (
                      product?.specs?.map((spec, index) => (
                        <div key={index} className={styles['spec-item']}>
                          <span className={styles['spec-label']}>{spec.lable}:</span>
                          <span className={styles['spec-value']}>{spec.value}</span>
                        </div>
                      ))
                    ) : (
                      <div className={styles['product-weight']}>No specifications</div>
                    )}
                  </div>
                  {/* 商品的售后暂时不做，后期放开售后功能 */}
                  {/* {(order.order_status === 3 || order.order_status === 4 || order.order_status === 5) && (
                    <button
                      className={styles['service-btn']}
                      onClick={() => getId && getId(order.id, 'service')}
                    >
                      Sales Service
                    </button>
                  )} */}
                  {/* 商品的售后暂时不做，后期放开售后功能 */}
                </div>
              </div>
              <div className={styles['order-price-info']}>
                <div className={styles['product-price']}>${product?.price}</div>
                <div className={styles['product-quantity']}>×{product?.quantity}</div>
                {order.products.length > 1 && (
                  <div className={styles['total-products']}>
                    Total: {order.products.length} items
                  </div>
                )}
              </div>
              <div className={styles['order-paid-info']}>
                <div className={styles['paid-label-box']}>
                  <div className={styles['paid-label']}>{t('YourTownloopOrdersList.PayAmount')}</div>
                  <div className={styles['paid-amount']}>${product.subtotalPrice}</div>
                </div>

                <div className={styles['paid-label-box']}>
                  <div className={styles['shipping-label']}>{t('YourTownloopOrdersList.ShippingFeeIncluded')}</div>
                  <div className={styles['shipping-fee']}>{order.shippingFee}</div>
                </div>
              </div>
              <div className={styles['order-actions']}>

                {(
                  order?.product_order_refund?.product_order_refund_status === 1 
                  && order.order_status === 3
                ) && (
                  // 已付款退款操作
                  <span 
                  className={styles['order-details2']}
                >Refunded</span>
                )}

                {/* <button 
                className={styles['repeat-btn']} 
                onClick={() => {
                  暂时注释掉Cart功能
                  handleAddToCart(order);
                }}
              >
                Cart
              </button> */}

                {/* <button 
                className={styles['repeat-cart']} 
                onClick={() => OrderDetails(product)}
                >Details</button> */}

                
              </div>
            </div>
          ))}


          {/* 商品信息区块 */}






        </div>
      ))}
    </div>
  );
};

export default YourTownloopOrdersList; 